import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrescriptionsNsIconComponent } from '../prescriptions-ns-icon/prescriptions-ns-icon.component';

export type NsStatus = 'standard' | 'non-standard' | 'pending';

export interface PrescriptionsItemVM {
  id: string;
  drugName: string;
  description: string;
  providerId: string;
  prescriptionDate: string;
  nsStatus: NsStatus;
}

@Component({
  selector: 'lib-prescriptions-item',
  standalone: true,
  imports: [CommonModule, PrescriptionsNsIconComponent],
  templateUrl: './prescriptions-item.component.html',
  styleUrl: './prescriptions-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrescriptionsItemComponent {
  public readonly item = input.required<PrescriptionsItemVM>();
}
